'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);

var MonthPickerItem = styled__default.div(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  width: 348px;\n  height: 38px;\n  padding: 8px 16px;\n  background: ", ";\n\n  &:hover{\n    background: ", ";\n  }\n"], ["\n  width: 348px;\n  height: 38px;\n  padding: 8px 16px;\n  background: ",
    ";\n\n  &:hover{\n    background: ", ";\n  }\n"])), function (_a) {
    var isSelected = _a.isSelected, theme = _a.theme;
    return (isSelected
        ? theme.colors.admin.modifiedMalibuBlueGhost : theme.colors.$white);
}, function (_a) {
    var theme = _a.theme;
    return (theme.colors.greys.adminGreyLight);
});
var templateObject_1;

exports.MonthPickerItem = MonthPickerItem;
